module.exports = __webpack_public_path__ + "media/images/lb/003-a94a0182c4389c694512c66c9117cdf8.svg";